// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1Pf99","search_container":"styles_search_container__3IDAD"};